import * as React from 'react';
import './HorizontalLoader.css';

const HorizontalSpinner: React.FC = () => {
  return (
    <>
      <div className="loading-ellipsis">
        <div className="ld">
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    </>
  );
}

export default HorizontalSpinner;